module.exports = __webpack_public_path__ + "static/media/wavey-fingerprint-white.ddc6c3f1.svg";